






















































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { MobileApp, UserPermission } from "@/shared/types";
import { Location } from "vue-router";
import { Validator } from "vee-validate";
import * as RouteNames from "@/admin/route-names";
import Pagination from "@/shared/components/ui/Pagination.vue";
import PageSizeSelectList from "@/shared/components/ui/PageSizeSelectList.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useMobileAppStore } from "@/shared/store/mobileApp";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component({
  components: {
    Pagination,
    PageSizeSelectList
  }
})

export default class MobileAppList extends Vue {
  notifierStore = useNotifierStore();
  mobileAppStore = useMobileAppStore();
  rolePermissionsStore = useRolePermissionsStore();

  @Prop() page: number;
  @Prop() routeToMobileAppList: (page: number) => Location;

  $validator: Validator;
  RouteNames = RouteNames;
  mobileApps: MobileApp[] = [];
  isSubmitting = false;
  searchTerm = "";
  showRemoveConfirmation = false;
  mobileAppToDelete: MobileApp = null;

  mounted (): void {
    this.fetchMobileAppList(false);
  }

  @Watch("page")
  onRouteValuePageNumberChanged (): void {
    this.fetchMobileAppList(false);
  }

  @Watch("mobileAppStore.mobileAppPages")
  onPagesChanged () {
    this.mobileApps = this.mobileAppStore.getMobileAppsByPageNumber(this.mobileAppStore.pageNumber);
  }

  fetchMobileAppList (clearState: boolean): void {
    if (!clearState) {
      this.mobileAppStore.setPageNumber(this.page);
    }
    this.mobileAppStore.search({
      pageNumber: this.mobileAppStore.pageNumber,
      clearState,
      searchTerm: this.searchTerm
    } as any).then(() => {
      this.mobileApps = this.mobileAppStore.getMobileAppsByPageNumber(this.mobileAppStore.pageNumber);
    }).catch(this.handleError);
  }

  onSearch (): void {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      this.mobileAppStore.setPageNumber(1);
      this.$router.push(this.routeToMobileAppList(1));
      this.fetchMobileAppList(true);
      this.isSubmitting = false;
    }
  }

  switchPageSize (): void {
    this.mobileAppStore.setPageNumber(1);
    this.$router.push(this.routeToMobileAppList(1));
    this.fetchMobileAppList(true);
  }

  clearSearch (): void {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      this.searchTerm = "";
      this.mobileAppStore.setPageNumber(1);
      this.$router.push(this.routeToMobileAppList(1));
      this.fetchMobileAppList(true);
      this.isSubmitting = false;
    }
  }

  get submitDisabled (): boolean {
    return this.mobileAppStore.mobileAppsFetchLoading || this.isSubmitting;
  }

  switchPage (toPage): void {
    this.$router.push(this.routeToMobileAppList(toPage));
  }

  showError (message: string): void {
    this.notifierStore.setDanger(message);
  }

  handleError (err: any): void {
    this.showError(
      (err && err.errorMessage) ||
      "Error processing your request. Please try again later"
    );
  }

  routeToMobileApp (id) {
    return { name: RouteNames.ManageMobileApp, params: { appid: id } };
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityMobileAppsEdit);
  }

  confirmDeleteMobileApp (mobileApp: MobileApp) {
    this.mobileAppToDelete = mobileApp;
    this.showRemoveConfirmation = true;
  }

  deleteMobileApp () {
    if (!this.mobileAppToDelete) {
      return;
    }

    this.mobileAppStore.deleteMobileApp(this.mobileAppToDelete.mobileAppId);
  }

  onRemoveConfirmationHidden () {
    this.mobileAppToDelete = null;
  }
}
